import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { SearchContactTypeModel } from '../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule, MatOption } from '@angular/material/core'
import { CommonModule } from '@angular/common'
import { MatTableModule } from '@angular/material/table'
import { ScheduleVehicleComponent } from '../schedule/schedule-vehicle/schedule-vehicle.component'
import { ScheduleDriverComponent } from './schedule-driver/schedule-driver.component'
import { MatCardModule } from '@angular/material/card'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatTabsModule } from '@angular/material/tabs'
import { ScheduleVehicleService } from '../../core/services/schedule/schedule-vehicle/schedule-vehicle.service'
import { SnackbarCustomService } from '../../shared/components/snackbar/snackbar-custom.service'
import { ScheduleDriverService } from '../../core/services/schedule/schedule-driver/schedule-driver.service'
import { ModalByBuyComponent } from './modal-by-buy/modal-by-buy.component'
import { ServiceOrderService } from '../../core/services/service/service-order/service-order.service'

@Component({
  selector: 'app-schedule',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatTabsModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ScheduleVehicleComponent,
    ScheduleDriverComponent,
    MatDialogModule,
    MatCardModule,
  ],
  templateUrl: './schedule.component.html',
  styleUrl: './schedule.component.scss',
  standalone: true,
})
export class ScheduleComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ScheduleComponent>,
    private dialog: MatDialog,
    private scheduleVehicleService: ScheduleVehicleService,
    private scheduleDriverService: ScheduleDriverService,
    private snackbar: SnackbarCustomService,
    private serviceOrderService: ServiceOrderService,
  ) {}

  @Output() responseEdit = new EventEmitter()
  @Output() responseViewEdit = new EventEmitter()

  selectedTabIndex = 0
  form!: FormGroup
  itemsList: any[] = []
  loading = false
  definet = false
  vehicleDates: any
  driverDates: any

  viewEdit: any = false

  idOs: any[] = []

  @Output() response = new EventEmitter<any>()
  editIndex: number | null = null
  editAgendaItem: any = null
  page = 1
  rows = 10
  numberRows = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  displayedColumns: string[] = ['date', 'startDate', 'endDate', 'action']
  columns: any[] = [
    { keyColumn: 'date', key: 'date', description: 'Data' },
    { keyColumn: 'startDate', key: 'startDate', description: 'Data Inicial' },
    { keyColumn: 'endDate', key: 'endDate', description: 'Data Final' },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  ngOnInit(): void {
    this.createForm()
    this.fillForm()
    this.viewEdit = this.data.viewMode
    if (this.data.item.status === 5) {
      this.definet = true
    }
  }

  formatHour(time: any): string {
    if (!time) return ''
    return time.slice(0, 5)
  }

  parseDateBR(dateStr: string): Date | null {
    if (!dateStr) return null
    const [day, month, year] = dateStr.split('/')
    return new Date(Number(year), Number(month) - 1, Number(day))
  }

  fillForm() {
    this.form.patchValue({
      dateInitial: this.parseDateBR(this.data.item.dataInicio),
      dateEnd: this.parseDateBR(this.data.item.dataFinal),
      startHours: this.formatHour(this.data.item.horaInicio),
      endHours: this.formatHour(this.data.item.horaFinal),
      status: this.data.item.descricaoStatus,
      typeService: this.data.item.descricaoTipoServico,
      event: this.data.item.nomeEvento,
      service: this.data.item.servico,
    })
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      dateInitial: ['', [Validators.required]],
      dateEnd: ['', [Validators.required]],
      startHours: ['', [Validators.required]],
      endHours: ['', [Validators.required]],
      service: ['', [Validators.required]],
      event: ['', [Validators.required]],
      typeService: ['', [Validators.required]],
      status: ['', [Validators.required]],
    })
  }

  addItemToList() {
    if (!this.form.valid) {
      this.form.markAllAsTouched()
      return
    }

    const formValue = this.form.value

    const dateStr = formValue.date ? new Date(formValue.date).toLocaleDateString('pt-BR') : ''

    const item = {
      date: dateStr,
      startDate: formValue.startHours,
      endDate: formValue.endHours,
    }
    this.itemsList.unshift(item)
    this.itemsList = [...this.itemsList]
    this.form.patchValue({
      date: '',
      startHours: '',
      endHours: '',
    })
  }

  editItem(item: any) {
    this.editIndex = this.itemsList.findIndex(
      (i) => i.date === item.date && i.startDate === item.startDate && i.endDate === item.endDate,
    )
    this.editAgendaItem = { ...item }
    this.form.patchValue({
      date: item.date,
      startHours: item.startDate,
      endHours: item.endDate,
    })
  }

  captureDateVehicle(element: any) {
    this.vehicleDates = element
    // this.selectedTabIndex = index;
  }

  goToTab(index: number) {
    this.selectedTabIndex = index
    // this.selectedTabIndex = index;
  }

  deleteItem(item: any) {
    this.itemsList = this.itemsList.filter(
      (i) => i.date !== item.date || i.startDate !== item.startDate || i.endDate !== item.endDate,
    )
  }

  onCheckboxChangeVehicle(event: any) {
    this.vehicleDates = {
      id: this.data.item.agendaVeiculoId,
      veiculoId: event.id,
      dataInicio: this.data.item.dataInicio,
      horainicio: this.data.item.horaInicio, // Formata a hora de início
      dataFinal: this.data.item.dataFinal,
      horaFinal: this.data.item.horaFinal, // Formata a hora final
      ordemServicoId: this.data.item.codigoOs,
    }
  }

  onCheckboxChangeDriver(event: any) {
    this.driverDates = {
      id: this.data.item.agendaMotoristaId,
      motoristaId: event.id,
      dataInicio: this.data.item.dataInicio,
      horainicio: this.data.item.horaInicio, // Formata a hora de início
      dataFinal: this.data.item.dataFinal,
      horaFinal: this.data.item.horaFinal, // Formata a hora final
      ordemServicoId: this.data.item.codigoOs,
    }

    // this.driverDates = event
  }

  saveEditAgendaItem() {
    if (this.editIndex !== null) {
      const formValue = this.form.value
      this.itemsList[this.editIndex] = {
        date: formValue.date ? new Date(formValue.date).toLocaleDateString('pt-BR') : '',
        startDate: formValue.startHours,
        endDate: formValue.endHours,
      }
      this.itemsList = [...this.itemsList]
      this.editIndex = null
      this.editAgendaItem = null

      this.form.patchValue({
        date: '',
        startHours: '',
        endHours: '',
      })
    }
  }

  reateForm(): void {
    this.form = this.formBuilder.group({
      date: ['', Validators.required],
      startHours: ['', Validators.required],
      endHours: ['', Validators.required],
    })
  }

  resetForm() {
    this.form.reset()
  }

  cancel() {
    this.editIndex = null
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  close() {
    this.dialogRef.close()
  }

  finalize(element: any) {
    if (element != 0) {
      this.driverDates = element
    } else {
      this.selectedTabIndex = element
    }
  }

  toUpdateStatus() {
    this.loading = true
    const item = {
      id: this.data.item.codigoOs,
      statusId: 5,
    }

    this.serviceOrderService.editServiceOrderEditStatus(item).subscribe({
      next: (res: any) => {
        this.snackbar.success(res.message)
        this.loading = false
        this.dialogRef.close()
      },
      error: (error: any) => {
        this.snackbar.error(error.message)
        this.loading = false
      },
    })
  }

  pushdates() {
    this.loading = true
    const itemDriver = this.driverDates
    const itemVehicle = this.vehicleDates

    if (this.data.item.status === 5) {
      this.scheduleVehicleService.editAgendaVeiculo(itemVehicle).subscribe({
        next: (res) => {
          this.loading = false
        },
        error: (err) => {
          this.snackbar.error(err.message)
          this.loading = false
        },
      })

      this.scheduleDriverService.editAgendaMotorista(itemDriver).subscribe({
        next: (res) => {
          this.loading = false
          this.snackbar.success('Agendamento editado com sucesso!')
          this.dialogRef.close()
          this.responseEdit.emit(res)
          // this.toUpdateStatus()
        },
        error: (err) => {
          console.error(err.message)
          this.loading = false
        },
      })
    } else {
      // Só motorista + OS: data e hora são opcionais e o back preenche com a janela da
      // própria OS (com duração padrão e virada de dia). Montar a janela pelo dado cru
      // da linha gravaria alocação de duração zero (11:00 às 11:00), que não se
      // sobrepõe a nada e deixa o motorista aparecendo livre o dia inteiro.
      const agendaMotorista = {
        motoristaId: itemDriver?.motoristaId,
        ordemServicoId: itemDriver?.ordemServicoId,
      }
      this.scheduleDriverService.createAgendaMotorista(agendaMotorista).subscribe({
        next: (res) => {
          this.snackbar.success(res.message)
          this.loading = false
        },
        error: (err) => {
          // 400 (OS inexistente/cancelada) e 409 (motorista já alocado) trazem a mensagem no corpo
          this.snackbar.errorRequest(err)
          this.loading = false
        },
      })
      this.scheduleVehicleService.createAgendaVeiculo(itemVehicle).subscribe({
        next: (res) => {
          this.loading = false
          this.toUpdateStatus()
          this.responseEdit.emit(res)
        },
        error: (err) => {
          console.error(err.message)
        },
      })
    }
  }

  toSendBuys() {
    const dialogRef = this.dialog.open(ModalByBuyComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '450px',
      width: '450px',
      maxHeight: '250px',
      height: '250px',
      panelClass: '',
      data: { item: this.data.item, dataDriver: this.driverDates, dataVehicle: this.vehicleDates },
    })
    // dialogRef.componentInstance.response.subscribe((response) => {
    //   this.data.item = response
    // })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.dialogRef.close(true)
      }
    })
  }
}
